import React, { useState } from "react";
import {AiOutlineMenu} from "react-icons/ai";
import {FiShoppingCart} from "react-icons/fi";
import {ImCross} from "react-icons/im";
import Logo from "../assets/logo.png";

const NavBar = () => {

    const [nav, setNav] = useState(true);

    const handleNav = () => {
        setNav(!nav);
    }

    return(
        <div id="navbar" className="flex justify-between items-center h-24 max-w-full mx-5 px-1 text-white">
            <div className="flex items-center">
                <a href="#navbar"> <img className="mt-5 h-24 rounded-full" src={Logo} /> </a>
                <a href="#navbar"> <h1 className="w-full text-4xl font-bold text-[#F08000] p-1">Yee Shin</h1> </a>
            </div>
            
            <ul className="hidden md:flex">
                <li className="p-4"><a href="#navbar">Home</a></li>
                <li className="p-4"><a href="#about">FAQ</a></li>
                <li className="p-4"><a href="#footer">Contact</a></li>
                <li className="p-4">
                    <a href="https://www.facebook.com/yeeshin.Hsipaw" target="blank">
                        <FiShoppingCart style={{ display: 'inline-block', verticalAlign: 'middle' }}/>  
                    </a> 
                </li>
            </ul>

            <div onClick={() => handleNav()} className="block md:hidden">
                {!nav ? <ImCross size={20}/> : <AiOutlineMenu size={30}/>}
            </div>

            <div className={!nav ? 'fixed left-0 top-0 w-[60%] border-r border-r-gray-900 h-full bg-[#000300] ease-in-out duration-500 md:hidden' : 'fixed left-[-100%] md:hidden'}>
                <h1 className="w-full text-4xl font-bold text-[#F08000] m-4">Yee Shin</h1>
                <ul className="p-4 uppercase">
                    <li className="p-4"><a href="#navbar"><button onClick={() => setNav(!nav)}>Home</button></a></li>
                    <li className="p-4"><a href="#about"><button onClick={() => setNav(!nav)}>FAQ</button></a></li>
                    <li className="p-4"><a href="#footer"><button onClick={() => setNav(!nav)}>Contact</button></a></li>
                    <li className="p-4">
                    <a href="https://www.facebook.com/yeeshin.Hsipaw" target="blank">
                         <button onClick={() => setNav(!nav)}>
                        <FiShoppingCart style={{ display: 'inline-block', verticalAlign: 'middle' }}/>  
                        </button>
                    </a> 
                </li>
                </ul>
            </div>
        </div>
    )
}

export default NavBar;